/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Card product type
 */
export type GetCardProductListResponseItemCardType = typeof GetCardProductListResponseItemCardType[keyof typeof GetCardProductListResponseItemCardType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCardProductListResponseItemCardType = {
  PHYSICAL: 'PHYSICAL',
  VIRTUAL: 'VIRTUAL',
} as const;
